import { secondAxios } from "../../../../../api/axios";

/**
 * Plant (project) records and plant-scoped tree fetches.
 * Each function does one HTTP call; payload shaping and cache updates
 * stay with the caller.
 */
export const fetchPlantWbs = async (plantId, clientName) => {
  const response = await secondAxios.get(
    `/project/plant/${plantId}/${clientName}`,
  );
  const plantProjects = Array.isArray(response.data) ? response.data : [];
  console.log("plantData", plantId, plantProjects);
  return plantProjects;
};

export const fetchPlantMcsTree = async (plantId) => {
  const response = await secondAxios.get(`/plant/${plantId}/mcs-tree`);
  return response.data;
};

// Same endpoint and payload shape as the Projects page's "Create New
// Project" dialog (Project/plant/index.jsx): the name is
// "<client prefix>-<number>".
export const createPlantRecord = async ({
  name,
  clientId,
  description,
  sharepointLink,
}) => {
  await secondAxios.post("/plant", {
    name,
    clientId,
    description,
    sharepointLink,
  });
};

// PUT '/plant/:id' takes the whole CreatePlantDto, but only assigns what it
// is given: leaving out clientId, sharepointLink and people keeps the ones
// already stored. `name` it always wants.
export const updatePlantRecord = async (plantId, changes) => {
  await secondAxios.put(`/plant/${plantId}`, changes);
};

export const deletePlantRecord = async (plantId) => {
  await secondAxios.delete(`/plant/${plantId}`);
};
